<template>
  <div class="right-selector">
    <van-popup
      class="right-selector__popup"
      v-model="showPopup"
      position="bottom"
    >
      <div class="right-selector__popup__header">
        <div class="title">请选择您要消耗的权益</div>
        <!-- <div
          class="button--close"
          @click="handleCancel"
        >暂不使用</div> -->
      </div>

      <section class="right-list__wrapper">
        <div
          v-for="(item, index) in rightOptions"
          :key="index"
          class="right_box"
          :class="{
            selected: item.isCheck,
          }"
          @click="check(item)"
        >
          <img
            src="@/assets/img/icon-sel.png"
            v-if="item.isCheck"
            alt=""
            class="right-item-header-img"
          >
          <img
            src="@/assets/img/icon-nor.png"
            v-else
            alt=""
            class="right-item-header-img"
          >
          <div class="rightName">{{ item.rightName }}</div>
          <div class="rightCode">权益ID:  {{ item.rightCode }}</div>
          <div class="rightInfo">权益范围:  <span class="info">{{ item.usrRange }}</span></div>
          <div class="rightInfo">增值产品:  <span class="info">{{ item.addProduct }}</span></div>
          <div class="rightInfo">权益限制:  <span class="info">{{ item.cycleType }}</span></div>
        </div>
      </section>
      <div class="right_bottom">
        <van-button
          type="default"
          class="btn"
          @click="handleCancel"
        >取消</van-button>
        <van-button
          type="info"
          class="btn"
          @click="submit"
        >确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { Toast } from 'vant';
export default {
  name: 'RightSelector',

  props: {
    rightOptions: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    return {
      showPopup: false
    };
  },

  computed: {
  },

  watch: {
  },

  methods: {
    openDialog() {
      this.showPopup = true;
    },
    handleCancel() {
      this.showPopup = false;
    },
    check(data) {
      this.$emit('check', data);
    },
    submit() {
      const rightOptions = (this.rightOptions || []).filter(item => item.isCheck);
      console.log(rightOptions, 'rightOptions');
      if (rightOptions.length <= 0) {
        Toast('请选择权益');
        return;
      }
      this.$emit('submit', rightOptions);
    }
  }
};
</script>

<style lang="scss" scoped>
.right-selector {
  &__content {
    height: 0.98rem;
    font-size: 0.32rem;
    .van-cell {
      padding: 0.25rem 0.4rem;
      font-size: inherit;
      height: 100%;
    }
  }

  &__popup {
    &__header {
      font-size: 0.32rem;
      padding: 0.26rem 0.4rem;
      display: flex;
      justify-content: space-between;
      box-shadow: 0px 1px 0px 0px rgba(230, 230, 230, 1);

      .title {
        font-family: PingFangSC-Medium;
      }
      .button--close {
        color: #c8c8c8;
      }
    }

    .right-list {
      &__wrapper {
        height: 8.2rem;
        overflow-y: scroll;
        margin-bottom: 1.2rem;
      }

      &__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 2.25rem;
        border-radius: 0.16rem;
        font-size: 0.28rem;
        margin: 0.24rem 0.4rem;
        padding-left: 0.4rem;
        padding-right: 0.24rem;
        background: #ffedcf;
        border: 1px solid #e3cfad;
        border-radius: 10px;

        &.is-disabled {
          background: #F7F6F2;
          border: 1px solid #e5dac7;
          border-radius: 0.1rem;
          opacity: .7;
        }

        .right-info {
          color: #787878;
          &--top {
            margin-bottom: 0.2rem;
            // width: 5.7rem;
            line-height: 0.36rem;

            .right-name {
              font-size: 0.26rem;
              color: #474747;
              margin-right: 0.1rem;
              font-family: PingFangSC-Medium;
            }

            .right-tag {
              display: inline-block;
              font-size: 0.2rem;
              background: #ef9356;
              color: #fff;
              border-radius: 0.02rem;
              box-sizing: border-box;
              height: 0.28rem;
              line-height: 0.28rem;
              padding: 0 0.1rem;
              transform: translateY(-0.04rem);
            }
          }

          .right-info--range {
            display: inline-block;
            white-space: nowrap;
            width: 4.6rem;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          &--bottom {
            color: #474747;
            font-size: 0.2rem;
            margin-bottom: 0.12rem;
            display: flex;
            flex-direction: row;
            align-items: center;

            .count {
              font-size: 0.16rem;
              margin-left: 0.15rem;
              background: #f29254;
              border-radius: 0.15rem;
              color: #fff;
              padding: 1px 0.14rem;
            }
          }

          &--detail {
            font-size: 0.2rem;
            margin-top: 0.16rem;
            display: flex;
            align-items: center;

            .extend {
              margin-left: 0.1rem;
              width: 0.24rem;
              height: 0.24rem;
            }
          }
        }

        .right-checkbox__wrapper {
          border-radius: 50%;
          background: #fff;
        }
      }
    }
  }

  &--detail {
    margin: 0.4rem;
    border-radius: 4px;

    .title {
      background: #e7f1fa;
    }

    .content {
      background: #ffffff;
    }
  }
  .right_box{
    width: 94vw;
    border: 1px solid #e6e6e6;
    padding: 0.2rem;
    box-sizing: border-box;
    margin: 0.2rem auto;
    color: #383838;
    position: relative;
    .right-item-header-img{
      position: absolute;
      top: -0.01rem;
      right: 0;
      width: 0.3rem;
    }
    .rightCode{
      font-size: 0.3rem;
    }
    .rightCode{
      color: #787878;
      font-size: 0.26rem;
      margin: 0.2rem 0;
      border-bottom: 1px dashed #d1d1d1;
      padding-bottom: 0.2rem;
    }
    .rightInfo{
      font-size: 0.26rem;
      // height: 0.4rem;
      line-height: 0.4rem;
      .info{
        color: #787878;
      }
    }
  }
  .selected{
    border: 1px solid #4398ff;
  }
  .right_bottom{
    position: fixed;
    bottom: 0;
    width: 100vw;
    background: #fff;
    display: flex;
    justify-content: space-around;
    padding: 0.2rem 0;
    box-sizing: border-box;
    border-top: 1px solid #d1d1d1;
    .btn{
      width: 3rem;
    }
  }
}
</style>
